import PhotoListApi from '../PhotoListApi';
import ICalendar from '../../calendar/ICalendar';
import * as types from './ActionTypes';

function getEditedPhotoOrdersSuccess(result: any) {
    return { type: types.GET_EDITED_PHOTO_ORDERS_SUCCESS, result };
}

export function getEditedPhotoOrders() {
    return (dispatch: (result: any) => void) =>
        PhotoListApi.getEditedPhotoOrders().then((result: any) => {
            dispatch(getEditedPhotoOrdersSuccess(result));
        });
}

function getUneditedPhotoOrdersSuccess(result: any) {
    return { type: types.GET_UNEDITED_PHOTO_ORDERS_SUCCESS, result };
}

function getUneditedFuturePhotoOrdersSuccess(result: any) {
    return { type: types.GET_UNEDITED_FUTURE_PHOTO_ORDERS_SUCCESS, result };
}

export function getUneditedPhotoOrders(date: any) {
    return (dispatch: (result: any) => void) =>
        PhotoListApi.getUneditedPhotoOrders(date).then((result: any) => {
            dispatch(getUneditedPhotoOrdersSuccess(result));
        });
}

export function getUneditedFuturePhotoOrders() {
    return (dispatch: (result: any) => void) =>
        PhotoListApi.getFutureOrders().then((result: any) => {
            dispatch(getUneditedFuturePhotoOrdersSuccess(result));
        });
}

function setOrderAsAssignedSuccess(
    orderId: number,
    userId: number,
    imageEditorName: string,
    assignedToCurrentUser: boolean
) {
    return {
        type: types.SET_ORDER_AS_ASSIGNED_SUCCESS,
        result: { orderId, userId, imageEditorName, assignedToCurrentUser }
    };
}

export function assignOrder(
    orderId: number,
    userId: number,
    imageEditorName: string,
    assignedToCurrentUser: boolean
) {
    return (dispatch: (result: any) => void) =>
        PhotoListApi.assignOrder(orderId, userId).then(() => {
            dispatch(
                setOrderAsAssignedSuccess(orderId, userId, imageEditorName, assignedToCurrentUser)
            );
        });
}

function setOrderAsUnassignedSuccess(orderId: number) {
    return { type: types.SET_ORDER_AS_UNASSIGNED_SUCCESS, result: orderId };
}

export function unAssignOrder(orderId: number) {
    return (dispatch: (result: any) => void) =>
        PhotoListApi.unAssignOrder(orderId).then(() => {
            dispatch(setOrderAsUnassignedSuccess(orderId));
        });
}
